<template>
<div class="chapter">
<div class="inner_page">
<h2 class="fmh">CONTENTS</h2>
<p class="contents" id="ch1"><span class="nl5"> </span><a href="#/Text/TNTC_Romans4">General preface</a></p>
<p class="contents" id="ch2"><span class="nl5"> </span><a href="#/Text/TNTC_Romans5">Author’s preface</a></p>
<p class="contents" id="ch3"><span class="nl5"> </span><a href="#/Text/TNTC_Romans6">Abbreviations</a></p>
<p class="contents" id="ch4"><span class="nl5"> </span><a href="#/Text/TNTC_Romans6a">Select bibliography</a></p>
<p class="linespace"></p>
<p class="contents" id="ch5"><span class="nl5"> </span><a href="#/Text/TNTC_Romans7"><span class="bold">Introduction</span></a></p>
<p class="linespace"></p>
<p class="contents" id="ch6"><a href="#/Text/TNTC_Romans7#rch1">1.<span class="nl2"> </span>The audience of the letter</a></p>
<p class="contents" id="ch7"><a href="#/Text/TNTC_Romans7#rch2">2.<span class="nl2"> </span>Date and provenance</a></p>
<p class="contents" id="ch8"><a href="#/Text/TNTC_Romans7#rch3">3.<span class="nl2"> </span>The integrity of the letter</a></p>
<p class="contents" id="ch9"><a href="#/Text/TNTC_Romans7#rch4">4.<span class="nl2"> </span>The occasion for the letter</a></p>
<p class="contents" id="ch10"><a href="#/Text/TNTC_Romans7#rch5">5.<span class="nl2"> </span>The nature of the letter</a></p>
<p class="contents" id="ch11"><a href="#/Text/TNTC_Romans7#rch6">6.<span class="nl2"> </span>Theological themes in Romans</a></p>
<p class="linespace"></p>
<p class="contents" id="ch12"><span class="nl5"> </span><span href="#/Text/TNTC_Romans8" title="Link target outside of Sample"><span class="bold">Analysis</span></span></p>
<p class="linespace"></p>
<p class="contents" id="ch13"><span class="nl5"> </span><span href="#/Text/TNTC_Romans9" title="Link target outside of Sample"><span class="bold">Commentary</span></span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// TNTC_Romans3.vue?18ed5b58